import AsyncStorage from '@react-native-async-storage/async-storage'

import { CartProduct } from '../../context/cart'
import { apiRequest } from '../request'

export type SaveCartResponse = {
  sessionKey: string
}

export const CART_SESSION_KEY = 'CART_SESSION_KEY'

const saveSessionKey = async (sessionKey: string) => {
  try {
    await AsyncStorage.setItem(CART_SESSION_KEY, sessionKey)
  } catch (error) {
    console.error('Error saving the Cart session key in the Storage', error)
  }
}

export const cart = {
  saveInMemory(product: CartProduct) {
    return apiRequest<SaveCartResponse>(`/cart`, {
      body: product,
      method: 'POST',
    }).then(async response => {
      const sessionKey = response.data?.sessionKey

      if (sessionKey) {
        await saveSessionKey(sessionKey)
      }

      return sessionKey
    })
  },

  update(sessionKey: string, product: Partial<CartProduct>) {
    return apiRequest<SaveCartResponse>(`/cart/${sessionKey}`, {
      body: product,
      method: 'PUT',
    }).then(async response => response.data?.sessionKey)
  },

  async getSessionKey() {
    return AsyncStorage.getItem(CART_SESSION_KEY).catch(err => {
      console.error('🔴 Error getting cart session from storage.', err)
      return null
    })
  },

  async getFromMemory() {
    const sessionKey = await this.getSessionKey()

    if (!sessionKey) return null

    return apiRequest<CartProduct>(`/cart/${sessionKey}`, {
      method: 'GET',
    }).then(response => response.data)
  },

  deleteSessionKey() {
    return AsyncStorage.removeItem(CART_SESSION_KEY)
  },
}
